import React from "react";
import { IndustryMultiSelect } from "./IndustryMultiSelect";

/* Step 3 — which activities the trade licence covers. */
export const IndustryStep = ({
  options = [],
  value = [],
  onChange = () => {},
  isLoading = false,
  errors = {},
}) => (
  <div className="grid gap-3.5">
    <IndustryMultiSelect
      options={options}
      value={value}
      onChange={onChange}
      isLoading={isLoading}
      error={errors.industries}
    />
    <p className="-mt-1 text-[12.5px] leading-[1.5] text-[var(--muted)] font-sans">
      Pick all the activities your trade license covers. We use NACE 2.0 —
      search by keyword to find the right code.
    </p>
  </div>
);

export default IndustryStep;
